import * as R from 'ramda';

const refreshFacebookPages = () => async (state, newFacebookPages) => {
    const userClientId = state.user.selectedUserClientId;

    return R.assocPath(
        ['clients', userClientId, 'socialAccounts', 'facebook', 'pages'],
        newFacebookPages,
        state,
    );
};

export default refreshFacebookPages;
